import { EScrollUpButtonType } from '../types';
import { IconActionChevronUp16, IconActionFilters16 } from '@cian/ui-kit-design-tokens/icons';

export const getIconByType = (type: EScrollUpButtonType) => {
  switch (type) {
    case 'filters':
      return IconActionFilters16;
    case 'up':
      return IconActionChevronUp16;

    default:
      return IconActionChevronUp16;
  }
};
